export enum ActionTypeNickname {

    updateUserNickname

}

export enum ActionTypeContactList {

    updateContactList,
    updateDidUnseenMessagesUpdate
}

export enum ActionTypePickedUserChat {

    updatePickedUserChat

}

export enum ActionTypeGeneralChat {

    updateGeneralChat

}